import { render, staticRenderFns } from "./TopMaisCuponsCard.vue?vue&type=template&id=6bc8b9c9"
import script from "./TopMaisCuponsCard.vue?vue&type=script&lang=js"
export * from "./TopMaisCuponsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports